var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%", "flex-direction": "row" } },
    [
      _c(
        "div",
        { staticStyle: { "min-width": "1050px", height: "100%" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showButton,
                        expression: "showButton"
                      }
                    ],
                    staticStyle: { width: "100%" }
                  },
                  [
                    _vm.btnEditVisible &&
                    _vm.privilege.button_jobSopTab_canUpdateJobSop
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "canUpdateJobSop",
                              disabled:
                                _vm.isEdit ||
                                _vm.isFromFinance ||
                                !_vm.canEditTab ||
                                _vm.controlledLocked,
                              type: "primary"
                            },
                            on: { click: _vm.btnEdit_clickHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.EditionStatus")) + " "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.btnSaveVisible
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "Save",
                              disabled: _vm.isEdit || _vm.isFromFinance,
                              type: "primary"
                            },
                            on: { click: _vm.btnSave_clickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
                        )
                      : _vm._e(),
                    _vm.btnCancelVisible
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "Cancel",
                              disabled: _vm.isEdit || _vm.isFromFinance,
                              type: "primary"
                            },
                            on: { click: _vm.btnCancel_clickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
                        )
                      : _vm._e(),
                    _vm.privilege.button_jobSopTab_canUpdateJobSopFrom3rd
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "canUpdateJobSopFrom3rd",
                              disabled:
                                _vm.isEdit ||
                                _vm.isFromFinance ||
                                !_vm.canEditTab ||
                                _vm.controlledLocked,
                              type: "primary"
                            },
                            on: { click: _vm.updateExternalStateHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.UpdateExternalState"))
                            )
                          ]
                        )
                      : _vm._e(),
                    !_vm.sopTemplateConfig ||
                    !_vm.sopTemplateConfig.forbidManualChangeTemplate
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "showChangeSopTemplateDialog",
                              type: "primary",
                              disabled:
                                _vm.isEdit ||
                                !_vm.canEditTab ||
                                _vm.controlledLocked
                            },
                            on: { click: _vm.showChangeSopTemplateDialog }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ReplaceTheSOPTemplate")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "refreshHandler",
                          type: "primary",
                          disabled:
                            _vm.isEdit ||
                            !_vm.canEditTab ||
                            _vm.controlledLocked
                        },
                        on: { click: _vm.refreshHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Refresh")))]
                    ),
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: {
                        color: "#1F75D5",
                        "margin-left": "10px",
                        "font-size": "16px"
                      },
                      on: {
                        click: function($event) {
                          _vm.showWarningRuleTip = true
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showWarningRuleTip,
                            expression: "showWarningRuleTip"
                          }
                        ],
                        staticStyle: { color: "#1F75D5" }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WarningRuleTips")))]
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showWarningRuleTip,
                          expression: "showWarningRuleTip"
                        }
                      ],
                      staticClass: "el-icon-close",
                      staticStyle: { color: "#1F75D5", "font-size": "16px" },
                      on: {
                        click: function($event) {
                          _vm.showWarningRuleTip = false
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          float: "right",
                          "margin-right": "10px",
                          color: "royalblue"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ApplyTheSopTemplateAs") +
                              (_vm.templateName || "")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "110px",
                    "label-position": "left"
                  }
                },
                _vm._l(_vm.dataSource, function(data) {
                  return _c(
                    "div",
                    { key: data.tracking.uuid },
                    [
                      data.visible && (data.tracking.isActive || _vm.isEditing)
                        ? _c(
                            "el-form-item",
                            { staticClass: "label-none custom" },
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  no: "isActive",
                                  disabled: !_vm.isEditing,
                                  title: _vm.$t("SeaExport.IsDisplay")
                                },
                                model: {
                                  value: data.tracking.isActive,
                                  callback: function($$v) {
                                    _vm.$set(data.tracking, "isActive", $$v)
                                  },
                                  expression: "data.tracking.isActive"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      data.visible && (data.tracking.isActive || _vm.isEditing)
                        ? _c(
                            "el-form-item",
                            { staticClass: "custom" },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.StrUtils.isEmpty(
                                            data.trackingInfo.uuid
                                          )
                                            ? _vm.$store.getters.language ===
                                              "zh"
                                              ? data.tracking.codeCname
                                              : data.tracking.codeEname
                                            : _vm.$store.getters.language ===
                                              "zh"
                                            ? data.trackingInfo.codeCname
                                            : data.trackingInfo.codeEname
                                        )
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticStyle: { float: "right" } },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: data.hasWarnInfo,
                                              expression: "data.hasWarnInfo"
                                            }
                                          ],
                                          staticClass:
                                            "el-icon-warning-outline",
                                          staticStyle: {
                                            color: "#F56C6C",
                                            "margin-left": "10px"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: data.hasWarnInfo,
                                                expression: "data.hasWarnInfo"
                                              }
                                            ],
                                            staticStyle: { color: "#F56C6C" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Sop.Warning"))
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    no: "subCode",
                                    value:
                                      data.trackingInfo.subCode === ""
                                        ? _vm.$t("SeaExport.Uncertain")
                                        : data.trackingInfo.subCode,
                                    disabled:
                                      !_vm.isEditing || !data.tracking.isActive
                                  },
                                  on: {
                                    input: function(val) {
                                      data.trackingInfo.subCode = val
                                    },
                                    change: function(p) {
                                      _vm.stateChangeHandler(data)
                                    }
                                  }
                                },
                                _vm._l(data.tracking.trackingDetail, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label:
                                        _vm.$store.getters.language === "zh"
                                          ? item.codeCname
                                          : item.codeEname,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("cargo-date-time-field-input", {
                                attrs: {
                                  disabled:
                                    !_vm.isEditing || !data.tracking.isActive
                                },
                                model: {
                                  value: data.trackingInfo.modifyDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      data.trackingInfo,
                                      "modifyDate",
                                      $$v
                                    )
                                  },
                                  expression: "data.trackingInfo.modifyDate"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: {
                                  width: "150px",
                                  "margin-left": "10px"
                                },
                                attrs: {
                                  no: "modifyByChineseName",
                                  controls: false,
                                  readonly: "",
                                  disabled:
                                    !_vm.isEditing || !data.tracking.isActive
                                },
                                model: {
                                  value: data.trackingInfo.modifyByChineseName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      data.trackingInfo,
                                      "modifyByChineseName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.trackingInfo.modifyByChineseName"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: {
                                  width: "200px",
                                  "margin-left": "10px",
                                  "margin-right": "10px"
                                },
                                attrs: {
                                  no: "remark",
                                  disabled:
                                    !_vm.isEditing || !data.tracking.isActive
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.txtRemarkChangeHandler(data)
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Remarks"),
                                      data.trackingInfo.remark,
                                      function(val) {
                                        data.trackingInfo.remark = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: data.trackingInfo.remark,
                                  callback: function($$v) {
                                    _vm.$set(data.trackingInfo, "remark", $$v)
                                  },
                                  expression: "data.trackingInfo.remark"
                                }
                              }),
                              _vm.hasSendEmailPermission
                                ? [
                                    data.tracking.isActive
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              no: "SendEMail",
                                              type: "primary",
                                              disabled:
                                                _vm.isFromFinance ||
                                                !_vm.cooperateEdit ||
                                                _vm.controlledLocked
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.sendEmailEventHandler(
                                                  data
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.SendEMail")
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "10px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_TheNodeIsShutDown"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                  ]
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !!_vm.job.masterFlag,
                                      expression: "!!job.masterFlag"
                                    }
                                  ],
                                  attrs: {
                                    no: "SyncToSmallTicket",
                                    type: "primary",
                                    disabled:
                                      _vm.isFromFinance ||
                                      !_vm.cooperateEdit ||
                                      _vm.controlledLocked
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.syncToSmallTicket(data)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SyncToSmallTicket")
                                    )
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _c("div", { staticClass: "section" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SeaExport.SopStateNote")))])
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: "10" },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "close" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.sendEmailDialog.visible
            ? _c("send-email-dialog", {
                attrs: {
                  visible: _vm.sendEmailDialog.visible,
                  context: _vm.context,
                  job: _vm.job,
                  source: "tabSopState",
                  "send-email-data": _vm.sendEmailDialog,
                  "send-call-back": _vm.sendCallBackEvent,
                  "show-content": _vm.sendEmailDialog.showContent
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.sendEmailDialog, "visible", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.isCrossTenantSeToSi
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-left": "10px",
                "min-width": "560px",
                float: "right",
                height: "100%"
              }
            },
            [
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c("div", { staticStyle: { margin: "5px" } }, [
                    _c("span", { staticStyle: { "font-size": "20px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("queryJob.AssociateBusinessSOPNode"))
                      )
                    ]),
                    _vm.relatedJobNo
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "10px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.BusinessNo")) +
                                "：" +
                                _vm._s(_vm.relatedJobNo)
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    _vm._l(_vm.targetDataSource, function(data) {
                      return _c(
                        "div",
                        { key: data.tracking.uuid },
                        [
                          data.visible
                            ? _c(
                                "el-form-item",
                                { staticClass: "label-none custom" },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      no: "isActive2",
                                      disabled: "",
                                      title: _vm.$t("SeaExport.IsDisplay")
                                    },
                                    model: {
                                      value: data.tracking.isActive,
                                      callback: function($$v) {
                                        _vm.$set(data.tracking, "isActive", $$v)
                                      },
                                      expression: "data.tracking.isActive"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          data.visible
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: {
                                    label: _vm.StrUtils.isEmpty(
                                      data.trackingInfo.uuid
                                    )
                                      ? _vm.$store.getters.language === "zh"
                                        ? data.tracking.codeCname
                                        : data.tracking.codeEname
                                      : _vm.$store.getters.language === "zh"
                                      ? data.trackingInfo.codeCname
                                      : data.trackingInfo.codeEname
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        no: "subCode2",
                                        value:
                                          data.trackingInfo.subCode === ""
                                            ? _vm.$t("SeaExport.Uncertain")
                                            : data.trackingInfo.subCode,
                                        disabled: ""
                                      },
                                      on: {
                                        input: function(val) {
                                          data.trackingInfo.subCode = val
                                        },
                                        change: function(p) {
                                          _vm.stateChangeHandler(data)
                                        }
                                      }
                                    },
                                    _vm._l(
                                      data.tracking.trackingDetail,
                                      function(item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label:
                                              _vm.$store.getters.language ===
                                              "zh"
                                                ? item.codeCname
                                                : item.codeEname,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c("cargo-date-time-field-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: data.trackingInfo.modifyDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          data.trackingInfo,
                                          "modifyDate",
                                          $$v
                                        )
                                      },
                                      expression: "data.trackingInfo.modifyDate"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.changeSopTemplateVisible,
            title: _vm.$t(
              "CargoMsg.Cargo_SelectTheSopTemplateToApplyToTheBusiness"
            ),
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.changeSopTemplateVisible = $event
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "350px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "show-side-bar": false,
              "row-data": _vm.rowData
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.changeJobSopTemplate }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.changeSopTemplateVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }